module.exports = __webpack_public_path__ + "static/img/4.dd338be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/eng/4.png
// module id = hpTb
// module chunks = 0